var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Suspense, useEffect, useState } from 'react';
import Header from './components/header/header';
import Sidebar from './components/sidebar/sidebar';
import { useLogout } from '@/presentation/hooks';
import { useRecoilValue } from 'recoil';
import { currentAccountState } from '../atoms/atoms';
import Styles from './main-dashboard-styles.scss';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { useLocation } from 'react-router';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { getLocalUrl } from '@/main/utils/file-utils';
import { Storage } from 'aws-amplify';
import { profileInfoState } from '@/presentation/pages/school-info/components';
import AdditionalHeaders from './components/additional-headers/additional-headers';
import { makeRemoteLogin, makeRemoteManageStripe } from '@/main/factories/usecases';
import HeaderActivities from './components/header/header-activities';
import useSessionTracker from '@/presentation/hooks/use-session-tracker';
import useUserTracker from '@/presentation/hooks/use-user-tracker';
import useRouterQuery from '@/presentation/hooks/use-router-query';
import TutorialApp from '../tutorial-app/tutorial-app';
import TSWidget from '../TS-widget/TSWidget';
import LoadingG from '../loading/loadingG';
const hideSideBar = (paramRoutes, currentRoute) => {
    if (currentRoute) {
        for (const item of paramRoutes) {
            if (currentRoute.startsWith(item.path))
                return item.hideSidebar;
        }
    }
    return false;
};
const MainDashboard = ({ routes, children, routeProfile, isActivitiesEnabled = false }) => {
    var _a, _b, _c, _d, _e;
    const { getCurrentAccount } = useRecoilValue(currentAccountState);
    const { toastContainer, showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    // internal state
    const [url, setUrl] = useState(null);
    const [logoutLoading, setLogoutLoading] = useState(false);
    const state = useRecoilValue(profileInfoState);
    const logout = useLogout();
    const user = getCurrentAccount();
    const location = useLocation();
    const { user: userDatabase, currentUserSession } = useUserSesssion();
    // sesion tracker
    useSessionTracker();
    const query = useRouterQuery();
    useUserTracker({ idModule: query.get('idModule'), idLesson: query.get('idLesson'), isActive: isActivitiesEnabled });
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (state.logoS3Path !== '' && state.logoS3Path !== null) {
                const stor = localStorage.getItem('user-database');
                const myObject = JSON.parse(stor);
                const result = yield Storage.get(state.logoS3Path, { download: true });
                if (myObject.user && myObject.user.client) {
                    myObject.user.client.logoS3Path = state.logoS3Path;
                    localStorage.setItem('user-database', JSON.stringify(myObject));
                }
                setUrl(getLocalUrl(result.Body));
            }
        }))();
    }, [state.logoS3Path]);
    const getUrl = () => __awaiter(void 0, void 0, void 0, function* () {
        var _f;
        // let stor = localStorage.getItem('user-database');
        const result = yield Storage.get((_f = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.client) === null || _f === void 0 ? void 0 : _f.logoS3Path, { download: true });
        setUrl(getLocalUrl(result.Body));
    });
    const onLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        setLogoutLoading(true);
        yield logout();
        setLogoutLoading(false);
    });
    useEffect(() => {
        var _a;
        if ((_a = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.client) === null || _a === void 0 ? void 0 : _a.logoS3Path)
            getUrl();
    }, [(_a = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.client) === null || _a === void 0 ? void 0 : _a.logoS3Path]);
    useEffect(() => {
        var _a;
        // log out user if status is Deactive
        if (((_a = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.status) === null || _a === void 0 ? void 0 : _a.description) === 'Deactive') {
            showCustomError('Error', 'Your account is deactivated. Please contact your administrator.');
            setTimeout(() => __awaiter(void 0, void 0, void 0, function* () { return onLogout(); }), 5000);
        }
        if ((currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscriptionStatus) === false || (currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription) === null) {
            showCustomError('Error', "You don't have an active subscription. Please contact your administrator.");
            setTimeout(() => __awaiter(void 0, void 0, void 0, function* () { return onLogout(); }), 5000);
        }
    }, [
        userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.id,
        (_b = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _b === void 0 ? void 0 : _b.id,
        currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscriptionStatus,
        currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.mainContent },
            React.createElement("div", { className: Styles.header }, isActivitiesEnabled ? (React.createElement(HeaderActivities, null)) : (React.createElement(Header, { logoutLoading: logoutLoading, routeProfile: routeProfile, user: userDatabase, onLogout: onLogout, schoolLogoUrl: url, 
                // headerTitle="Admin Panel"
                profile: (_e = (_d = (_c = user === null || user === void 0 ? void 0 : user.signInUserSession) === null || _c === void 0 ? void 0 : _c.idToken) === null || _d === void 0 ? void 0 : _d.payload['cognito:groups']) === null || _e === void 0 ? void 0 : _e.join(','), additionalHeaders: React.createElement(AdditionalHeaders, { login: makeRemoteLogin(), manageStripe: makeRemoteManageStripe() }) }))),
            !hideSideBar(routes, location.pathname) && !isActivitiesEnabled && (React.createElement("div", { className: Styles.sidebar },
                React.createElement(Sidebar, { items: routes }))),
            React.createElement(Suspense, { fallback: React.createElement(LoadingG, { text: isActivitiesEnabled ? null : 'Page is loading...' }) },
                React.createElement("div", { className: !isActivitiesEnabled ? Styles.content : Styles.contentActivities }, children))),
        React.createElement(TSWidget, null),
        React.createElement(TutorialApp, null),
        toastContainer));
};
export default MainDashboard;
